module.exports = __webpack_public_path__ + "static/media/ServiceLandingImages2.564a6e9d.svg";